import React, { useMemo } from 'react';

import Dropdown from 'components/Dropdown';

import DropdownMenuItemComponent from './DropdownMenuItem';
import * as S from './styles';

type Props = {
  menuItems: DropdownMenuItem[];
  capitalCase?: boolean;
  menuStyle?: React.CSSProperties;
} & Omit<ComponentProps<typeof Dropdown>, 'menu' | 'popupRender'>;

const DropdownMenu: React.FC<React.PropsWithChildren<Props>> = ({
  menuItems,
  capitalCase,
  menuStyle,
  children,
  ...props
}) => {
  const menu = useMemo(
    () => (
      <S.Menu style={menuStyle} onClick={(e) => e.domEvent.stopPropagation()}>
        {menuItems.map(({ hoverColor, ...props }) => (
          <DropdownMenuItemComponent
            key={props.itemKey}
            {...props}
            hoverColor={hoverColor}
            capitalCase={capitalCase}
          />
        ))}
      </S.Menu>
    ),
    [capitalCase, menuItems, menuStyle]
  );

  return (
    <Dropdown popupRender={() => menu} {...props} trigger={props.trigger || ['click']}>
      {children}
    </Dropdown>
  );
};

export default DropdownMenu;
